import { render, staticRenderFns } from "./WorkSummary.vue?vue&type=template&id=036b6cf8"
import script from "./WorkSummary.vue?vue&type=script&lang=js"
export * from "./WorkSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports